const items = [
    {
        "type": "satellite_grouping_player",
        "locations": ["Iraí", "Passaúna", "Piraquara I e II"],
        "satellites": [
            {
                name: "1Band S1",
                title: "Sentinel-1",
                description:
                    "Imagem SAR (Synthetic Aperture Radar). Possibilita monitoramento contínuo, não tem influência de nuvens.",
            },
            {
                name: "4Band S2",
                title: "Sentinel-2",
                description:
                    "Imagem Multiespectral. Permite gerar composições coloridas e com infravermelho. Depende da cobertura de nuvens.",
            },
            {
                name: "NDVI S2",
                title: "NDVI",
                description:
                    "Índice de vegetação (Sentinel-2). Destaca presença de vegetação. Usa infravermelho e depende da cobertura de nuvens.",
            },
            {
                name: "NDWI S2",
                title: "NDWI",
                description:
                    "Índice de água (Sentinel-2). Destaca presença d’água. Usa infravermelho e depende da cobertura de nuvens.",
            },
        ],
    }
];

export default items;